// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1_EUW","cls2":"CreateSocialItemModal-cls2_w8J CreateSocialItemModal-cls1_EUW","center":"CreateSocialItemModal-center_Udg"};